<!-- <app-notification-settings *ngIf="sharedData"></app-notification-settings>
<div class="download-posts post-full-screen-download-container">
  <button class="download-posts-button-container" (click)="notificationSettings()" matTooltip="Notification Settings">
    <img alt="settings" [src]="'images/settings.svg' | assetUrl" class="icon-mr-5" />
    <span class="download-posts-button-container-title">Notification Settings</span>
  </button>
</div> -->
@if (!showPostDetails) {
  <div class="post-comments-container">
    <!-- <div class="container-header">
    <div class="folder-name folder-display-name" [matTooltip]="displayName">
      <span>
        <img [src]="'images/application.svg' | assetUrl" alt="application icom" class="no-width-icon" />
      </span>
      <span class="display-name" style="display: block;">{{displayName}}</span>
    </div>
    <div class="folder-actions">
      <span class="folder-actions-subscription">{{
        subscribe ? "Subscribed" : ""
      }}</span>
      <span (click)="updatePostSpaceLevelSubscription()" [matTooltip]="subscribe ? 'Unsubscribe' : 'Subscribe'">
        <img class="cursor-pointer" [class]="subscribe ? '' : 'icon-grey'" [src]="
            (subscribe ? 'images/bell.svg' : 'images/bell_cross.svg')
              | assetUrl
          " alt="unsubscribe icon" />
        </span>
      </div>
    </div> -->
    <div class="post-container posts-scroll">
      <div class="editor">
        <exp-quill-rte (updateValueChange)="addPost($event)" [atMentionConfig]="atMentionConfig"></exp-quill-rte>
      </div>
      <!-- <collaboration-ui-spinner *ngIf="showLoader || collaborationService.showPostLoader"
    [overlay]="true"></collaboration-ui-spinner> -->
    @for (post of orderPosts(posts); track trackItemById(i, post); let i = $index) {
      <app-shared-post-details (sharedCommentEventEmitter)="handleDetailsActions($event)" [post]="post" [atMentionConfig]="atMentionConfig"></app-shared-post-details >
    }
  </div>
</div>
}
@if (showPostDetails) {
  <div>
    <div class="post-details-container">
      <div class="container-header">
        <div class="back-arrow">
          <span>
            <img alt="arrow left" [src]="'images/arrow_left.svg' | assetUrl" (click)="backToPosts()"
              class="cursor-pointer" draggable="false" />
            </span>
          </div>
          <div class="title">Post details</div>
        </div>
        <div class="fs-post-details">
          <app-shared-post-details [isPostDetailView]="true" [post]="selectedPost"></app-shared-post-details>
        </div>
      </div>
    </div>
  }